import "./FloatingDropdownWithArrow.css";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import Arrow from "../../../../assets/images/rightAnglePath.svg";
import dropdownAngle from "../../../../assets/images/dropdownAngle.svg";
import { useSelector } from "react-redux";

const FloatingDropdownWithArrow = ({
  className = "",
  id,
  label,
  options,
  selectedValue,
  disabled = false,
  disabledOptions = [],
  setSelectedValue,
  showLabelAnimation = false,
  focusedAllowed = true,
  bgWhite = false,
  onSelectedBgTrue = false,
  setDisplayWarningModal = false,
  noSelectedBg = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });

  const buttonRef = useRef(null);
  const dropdownRef = useRef(null);
  const user = useSelector((state) => state.user?.user);

  const handleDropdownToggle = () => setIsOpen((prevState) => !prevState);

  const handleOptionSelect = (value) => {
    setIsOpen(false);
    setSelectedValue(value);
  };

  const calcPosition = () => {
    if (!buttonRef.current) return;
    const rect = buttonRef.current.getBoundingClientRect();
    const estimatedHeight = options.length * 45 + 10;
    const spaceBelow = window.innerHeight - rect.bottom;
    const openUpward = spaceBelow < estimatedHeight;
    setDropdownPosition({
      top: openUpward ? rect.top - estimatedHeight - 5 : rect.bottom + 5,
      left: rect.left,
    });
  };

  useLayoutEffect(() => {
    if (isOpen) calcPosition();
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) return;
    window.addEventListener("scroll", calcPosition, true);
    return () => window.removeEventListener("scroll", calcPosition, true);
  }, [isOpen]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        buttonRef.current &&
        !buttonRef.current.contains(event.target) &&
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      )
        setIsOpen(false);
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  return (
    <div
      className={`form-floating customDropdownComponent ${className}`}
      ref={dropdownRef}
    >
      <button
        className={`dropdownButton ${isOpen ? "active" : ""} ${
          selectedValue && focusedAllowed
            ? "has-value"
            : selectedValue && !noSelectedBg
            ? "has-white-background"
            : ""
        }
         ${isOpen && bgWhite ? "bg-white" : ""}
         ${isOpen && selectedValue ? "bg-white" : ""}
        `}
        onClick={() => {
          if (disabled) return;
          if (
            setDisplayWarningModal &&
            !user?.binanceCredentials?.isConnected &&
            !user?.bybitCredentials?.isConnected
          ) {
            setDisplayWarningModal(true);
            return;
          }
          handleDropdownToggle();
        }}
        ref={buttonRef}
        disabled={disabled}
      >
        <span
          className={`dropdown-selected ${
            !selectedValue ? "placeholder" : ""
          } ${showLabelAnimation ? "animation_text_field" : ""}
          ${onSelectedBgTrue && selectedValue ? "selectedTrue" : ""}
          `}
        >
          {selectedValue || label}
        </span>
        <span
          className={`dropdownArrow ${isOpen && "rotate"} ${
            selectedValue && bgWhite && "opacity100"
          }`}
          style={{ opacity: selectedValue && 1 }}
        >
          <img alt="" src={dropdownAngle} />
        </span>
      </button>
      {showLabelAnimation && (
        <label
          className={`floating-label ${
            isOpen || selectedValue ? "active" : ""
          } ${label === "Select Social Channel" ? "no-padding-left" : ""}`}
          htmlFor={id}
        >
          {label}
        </label>
      )}
      {/* {!selectedValue && !showLabelAnimation && (
        <label
          className={`floating-label ${
            isOpen || selectedValue ? "activeLabel" : ""
          } ${label === "Select Social Channel" ? "no-padding-left" : ""}`}
          htmlFor={id}
        >
          {label}
        </label>
      )} */}
      {isOpen && (
        <div
          className="dropdownContent"
          style={{ position: "fixed", top: dropdownPosition.top, left: dropdownPosition.left }}
        >
          {options.map((option, index) => {
            const isOptionDisabled = disabledOptions.includes(option);
            return (
              <p
                className={`dropdown-option${isOptionDisabled ? " dropdown-option--disabled" : ""}`}
                key={index}
                onClick={() => !isOptionDisabled && handleOptionSelect(option)}
                style={isOptionDisabled ? { opacity: 0.4, cursor: "not-allowed", pointerEvents: "none" } : {}}
              >
                <span className="span1">{option}</span>
                <span className="arrowspan">
                  <img alt="" src={Arrow} />
                </span>
              </p>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default FloatingDropdownWithArrow;
